import React from 'react';
import cx from 'classnames';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import { get } from 'lodash';

import { paths } from 'config/path_helpers';

interface Props {
  buttonName: string;
}

const EuTerms: React.FC<Props> = (props) => {
  const { errors } = useFormikContext();
  const hasError = !!get(errors, 'termsAndPolicyAccepted');

  return (
    <div className={cx('form-group', { 'has-error': hasError })}>
      <span className="text-danger">
        <small><ErrorMessage name="termsAndPolicyAccepted" /></small>
      </span>

      <label className="control-label checkbox u-margin-L-m text-gray-light font-weight-normal">
        <Field component="input" type="checkbox" name="termsAndPolicyAccepted" />
        <span>
          I consent to Magoosh using my personal data to create my account and record my progress, and to
          receiving study tips, promotions, and other useful opportunities. We promise to treat your data with
          the utmost care and you can unsubscribe from messaging at any time. By clicking &quot;{props.buttonName}
          &quot;, you agree to our{' '}
          <a href={paths.terms()} target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href={paths.privacy()} target="_blank" rel="noopener noreferrer">
            Privacy Policy.
          </a>
        </span>
      </label>
    </div>
  );
};

export default EuTerms;
